import { usePdpQuoteQuery } from '@coverright/data-access/medicare';
import { useUserProfile } from '../enrollment/use-user-profile';

export const usePdpQuote = () => {
  const profile = useUserProfile();
  const { data } = usePdpQuoteQuery({
    variables: { id: profile?.pdpQuoteId },
    skip: !profile?.pdpQuoteId,
  });
  return data?.pdpQuote;
};
